import { useARC } from "providers/ARC/ARCProvider";
import { useLightControl } from "providers/ARC/LightControlProvider";

import FunctionalButton from "components/layout/FunctionalButton";

import { ConnectionState } from "lib/consts/ARC/connection";
import { LightState } from "lib/consts/ARC/light";

import { ReactComponent as LightOffIcon } from "assets/svgs/ARC/LightOff.svg";
import { ReactComponent as LightOnIcon } from "assets/svgs/ARC/LightOn.svg";

const LightButton = () => {
    const { connectionState } = useARC();
    const { lightState, toggleLight, isToggling } = useLightControl();

    const isConnectedToARC = connectionState === ConnectionState.Connected;

    return (
        <FunctionalButton
            className={`control-button-type3 ${
                lightState === LightState.ON && "control-button-active"
            } ${(!isConnectedToARC || isToggling) && "control-button-disable"}`}
            icon={
                connectionState === ConnectionState.Connected ? (
                    lightState === LightState.ON ? (
                        <LightOnIcon className="w-6" />
                    ) : (
                        <LightOffIcon className="w-6" />
                    )
                ) : (
                    <LightOffIcon className="w-6 text-black70" />
                )
            }
            hoverText="Light"
            disabled={!isConnectedToARC || isToggling}
            onClick={() => toggleLight()}
        />
    );
};

export default LightButton;
